import { useContext } from "react";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { BotType } from "@shared/types";
import { BotFormType } from "@shared/features/bots/BotForm/common/types";
import { useClientsData, useIsSubUser } from "@shared/utils/hooks/misc";

const useShowNoAccountCard = () => {
  const { botType, botFormType, isChannelConfiguration } =
    useContext(BotFormContext) || {};
  const { writableActiveClientsData, getClientsListStatus } = useClientsData();
  const isSubUser = useIsSubUser();
  return (
    !!botType &&
    !!botFormType &&
    !EDIT_FORM_TYPES.includes(botFormType) &&
    !isChannelConfiguration &&
    botType !== BotType.TRADING_VIEW_SIGNALS &&
    !isSubUser &&
    getClientsListStatus.isSuccess &&
    !writableActiveClientsData?.length
  );
};

export default useShowNoAccountCard;

const EDIT_FORM_TYPES = [BotFormType.EDIT, BotFormType.BULK_EDIT];
